var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents-inner" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", {
      staticClass: "mt20 pega-pre-wrap",
      attrs: { "data-test": "businessContent" },
      domProps: { textContent: _vm._s(_vm.companyInfo.businessContent) },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMoreShow,
            expression: "isMoreShow",
          },
        ],
        staticClass: "mt20",
        attrs: { "data-test": "other-content" },
      },
      [
        _vm.companyInfo.established
          ? [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "mt20", attrs: { "data-test": "established" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.companyInfo.established) +
                      "\n      "
                  ),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.companyInfo.capital
          ? [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "mt20", attrs: { "data-test": "capital" } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.companyInfo.capital) + "\n      "
                  ),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.companyInfo.sale
          ? [
              _vm._m(3),
              _vm._v(" "),
              _c("p", { staticClass: "mt20", attrs: { "data-test": "sale" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.companyInfo.sale) + "\n      "
                ),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isShow.employee
          ? [
              _vm._m(4),
              _vm._v(" "),
              _vm.companyInfo.employeeNumber
                ? _c(
                    "p",
                    {
                      staticClass: "mt20",
                      attrs: { "data-test": "employeeNumber" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.companyInfo.employeeNumber) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.companyInfo.averageAge
                ? _c(
                    "dl",
                    {
                      staticClass: "bg-blue-box mt15",
                      attrs: { "data-test": "averageAge" },
                    },
                    [
                      _c("dt", [_vm._v("平均年齢")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.companyInfo.averageAge))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.companyInfo.midCareerPercentage
                ? _c(
                    "dl",
                    {
                      staticClass: "bg-blue-box mt10",
                      attrs: { "data-test": "midCareerPercentage" },
                    },
                    [
                      _c("dt", [_vm._v("中途入社の割合")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.companyInfo.midCareerPercentage)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isShow.representative
          ? [
              _vm._m(5),
              _vm._v(" "),
              _vm.companyInfo.representative
                ? _c(
                    "p",
                    {
                      staticClass: "mt20",
                      attrs: { "data-test": "representative" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.companyInfo.representative) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.companyInfo.representativeProfile
                ? _c(
                    "dl",
                    {
                      staticClass: "bg-blue-box mt15",
                      attrs: { "data-test": "representativeProfile" },
                    },
                    [
                      _c("dt", [_vm._v("代表者略歴")]),
                      _vm._v(" "),
                      _c("dd", {
                        staticClass: "pega-pre-wrap",
                        domProps: {
                          textContent: _vm._s(
                            _vm.companyInfo.representativeProfile
                          ),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.companyInfo.note
          ? [
              _vm._m(6),
              _vm._v(" "),
              _c("p", {
                staticClass: "mt20 pega-pre-wrap",
                attrs: { "data-test": "note" },
                domProps: { textContent: _vm._s(_vm.companyInfo.note) },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.companyInfo.hp
          ? [
              _vm._m(7),
              _vm._v(" "),
              _c("p", { staticClass: "mt20", attrs: { "data-test": "hp" } }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.companyInfo.hp,
                      target: "_blank",
                      rel: "nofollow",
                    },
                  },
                  [_vm._v(_vm._s(_vm.companyInfo.hp))]
                ),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.isShowAccordion
      ? _c(
          "div",
          { attrs: { id: "accordion-switch", "data-test": "more-show-div" } },
          [
            _c(
              "span",
              {
                style:
                  "background-image: url(" +
                  _vm.userCommonImageUrlForSp +
                  "/" +
                  _vm.moreShowIconName +
                  "); background-repeat: no-repeat; background-position: left; background-size: 8px 8px;",
                attrs: { "data-test": "more-show-span" },
                on: {
                  click: function ($event) {
                    _vm.isMoreShow = !_vm.isMoreShow
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.isMoreShow ? "閉じる" : "会社概要をもっと見る") +
                    "\n    "
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("事業内容")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "established-title" },
      },
      [_c("span", [_vm._v("設立")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "capital-title" } },
      [_c("span", [_vm._v("資本金")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "sale-title" } },
      [_c("span", [_vm._v("売上高")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "employeeNumber-title" },
      },
      [_c("span", [_vm._v("従業員数")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "representative-title" },
      },
      [_c("span", [_vm._v("代表者")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "note-title" } },
      [_c("span", [_vm._v("備考")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "hp-title" } },
      [_c("span", [_vm._v("企業HP")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }